export type PaymentOrderId = string | number;

const SCHEDULED_DOWNLOAD_METHODS = new Set(["WT", "WTO"]);

/**
 * Scheduled payment previews may only download wire-transfer receipts that
 * have an order id on the exact clientsScheduleCustomData record being shown.
 */
export const getScheduledPaymentDownloadOrderId = (
  paymentMethod: string | null | undefined,
  orderId: PaymentOrderId | null | undefined
): PaymentOrderId | null => {
  if (!paymentMethod || !SCHEDULED_DOWNLOAD_METHODS.has(paymentMethod)) {
    return null;
  }

  if (typeof orderId === "string") {
    return orderId.trim() ? orderId : null;
  }

  return typeof orderId === "number" && Number.isFinite(orderId) && orderId > 0
    ? orderId
    : null;
};
